function waitForElement(selector, callback) {
  var interval = setInterval(function () {
    var element = document.querySelector(selector);
    if (element) {
      clearInterval(interval);
      callback(element);
    }
  }, 100);
}

waitForElement('.product-single__title', function(title) {
  var existing = document.querySelector('.product-rating');
  if (existing) existing.remove();

  var rating = document.createElement('div');
  rating.className = 'product-rating';
  rating.innerHTML = `
    <span class="reviews-count">Over 2.605 anmeldelser</span>
    <span class="separator">|</span>
    <span class="rating-score">4,7/5</span>
    <span class="verified-check">✓ Bekræftede køb</span>
  `;

  // title.insertAdjacentElement('afterend', rating);
});